import {
  GET_PROJECT_REPORT,
  SET_PROJECT_ANALYTICS_LOADING,
  GET_PROJECT_ANALYTICS,
} from "../contants";
import { buildMainGraphData } from "/@src/views/app/projects/graphData";

const initialState = {
  analyticsLoading: true,
  reports: [],
  projectAnalytics: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECT_REPORT: {
      const { projectSlug, statName, data } = action.payload;
      return {
        ...state,
        reports: {
          ...state.reports,
          [projectSlug]: {
            ...state.reports[projectSlug],
            [statName]: buildData(statName, data),
          },
        },
      };
    }
    case SET_PROJECT_ANALYTICS_LOADING:
      return { ...state, analyticsLoading: action.payload };
    case GET_PROJECT_ANALYTICS:
      return { ...state, projectAnalytics: action.payload };
    default:
      return state;
  }
};

export default reducer;

const buildData = (statName, data) => {
  switch (statName) {
    case "topStats": {
      return data.map(d => {
        return {
          ...d,
          metric: selectMainGraphMetric(d.name)
        }
      })
    }
    case "mainGraph": {
      return buildMainGraphData(data || { labels: [], plot: [] });
    }
    default:
      return data;
  }
};

  const selectMainGraphMetric = (name) => {
    let metric = null;
    switch (name.toLowerCase()) {
      case "unique visitors":
        metric = "visitors";
        break;
      case "total visits":
        metric = "visits";
        break;
      case "total pageviews":
        metric = "pageviews";
        break;
      case "views per visit":
        metric = "views_per_visit";
        break;
      case "bounce rate":
        metric = "bounce_rate";
        break;
      case "visit duration":
        metric = "visit_duration";
        break;
      default: {
      }
    }
    return metric
  };